export const GET_STORES = 'stores/GET_STORES';
export const GET_STORES_SUCCESS = 'stores/GET_STORES_SUCCESS';
export const GET_STORES_FAILED = 'stores/GET_STORES_FAILED';
